import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { getBrandCustom } from "Util/getCustomColor";
import { colors } from "@zapalacorp/tokens";

export const CompanySlugContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
}));

export const CompanySlugSubdomain = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "1fr 20fr 1fr",
  gridColumnGap: "10px",
  alignItems: "center",
}));

export const CompanyInfoLabel = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "24px",
  color: getBrandCustom("darkPrimaryColor", colors.brandBlue600),
}));

export const CompanySlugInfo = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

export const CompanySlugUrl = styled("span")(() => ({
  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "24px",
}));

export const CompanyLogoAndIconInfo = styled("div")(() => ({
  background: "#EFF8FF",
  padding: "10px",
  height: "32px",
  borderRadius: "100px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: 0,
  right: 0,
}));

export const CompanyLogoAndIconTooltipContainer = styled(Grid)(() => ({
  gap: "10px",
}));

export const DetailsFieldTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "150%",
  color: "#465869",
}));

export const Separator = styled("hr")(() => ({
  width: "100%",
  height: 0,
}));

const styles = makeStyles(() => ({
  companyForm: {
    padding: "16px",
    border: "1px solid #E4E7EC",
    borderRadius: "12px",
    marginBottom: "24px",
  },

  companyFormContainer: {
    margin: 0,
    position: "relative",
  },

  skeleton: {
    transform: "none",
    marginBottom: "32px",
    width: "100%",
  },

  businessAddressLabelContainer: {
    marginTop: "16px",
    marginBottom: 24,
  },

  businessLabelContainer: {
    marginTop: "24px",
    marginBottom: 24,
  },

  businessLabel: {
    fontWeight: 700,
    color: "#465869",
    lineHeight: "18px",
    fontSize: "16px",
    fontFamily: `'Manrope', sans-serif`,
  },

  companyActions: {
    fontWeight: "bold",
    color: "#465869",
    lineHeight: "18px",
    fontSize: "18px",
    fontFamily: `'Manrope', sans-serif`,
  },

  buttonClose: {
    background: "#FFF",
    color: "#F97066",
    fontSize: "16px",
    fontWeight: 700,
    "&:hover": {
      color: "#F97066",
    },
  },

  buttonAdd: {
    fontSize: "16px",
    fontWeight: 700,
  },

  buttonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "16px 40px",

    "& span": {
      fontWeight: 700,
    },
  },

  iconContainer: {
    width: "56px",
    height: "56px",

    "& span": {
      display: "none",
    },
  },

  termsAccepted: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#465869",
  },
}));

export default styles;
